export { MetabotIcon } from "./MetabotIcon";
export type { MetabotIconProps } from "./MetabotIcon";
